export default defineNuxtPlugin((nuxtApp) => {
  const { addRumError } = useAcvDatadog();

  nuxtApp.vueApp.config.errorHandler = (error, context) => {
    // console log all client side errors when in development
    console.error('Error ==>', error, context);
    if (process.env.NODE_ENV === 'development') {
      console.error('Error ==>', error, context);
    }
  };

  // Handle uncaught errors outside of Nuxt/Vue
  if (import.meta.client) {
    // Global error handler for uncaught exceptions
    window.addEventListener('error', (event) => {
      console.log('Error handler caught:', event.error || event.message);

      const magicLinkToken = window.localStorage.getItem('magic_link_token');
      const accessToken = window.localStorage.getItem('access_token');

      // send error to datadog and include tokens
      addRumError(event.error || new Error(event.message), {
        magicLinkToken,
        accessToken,
      });
    });
  }
});
